import { useTranslations } from 'next-intl';

import { type AccountLinkingCredential } from './types';

export function useGetInitialError(
  storedAccountLinkingCredential: AccountLinkingCredential
) {
  const t = useTranslations('login');

  if (!storedAccountLinkingCredential) {
    return '';
  }

  if (Object.hasOwn(storedAccountLinkingCredential, 'googleIdToken')) {
    return t('SSO.AccountExistsSpecific', { socialProvider: 'Google' });
  }

  if (Object.hasOwn(storedAccountLinkingCredential, 'appleId')) {
    return t('SSO.AccountExistsSpecific', { socialProvider: 'Apple' });
  }

  if (Object.hasOwn(storedAccountLinkingCredential, 'ebay_id')) {
    return t('SSO.EbayAccountNotLinked');
  }

  return '';
}
